import { API } from "../config";


const login = (mobile_no: string | number) =>
    API.post("/check/mobile", { mobile_no }).then(
        (res) => res,
        (err) => err
    );

export const sendOtp = (mobile_no: string | number) =>
    API.post("/send/otp", { mobile_no }).then(
        (res) => res,
        (err) => err
    );

export const guestOtp = (country_code: string | number, number: string | number) =>
    API.post("/send/guest/otp", { country_code, number }).then(
        (res) => res,
        (err) => err
    );
export const checkGuestOtp = (res: { OTP: string, phoneNumber: string, countryCode: string, firstName: any }) =>
    API.post("/check/guest/otp", {

        code: res.OTP,
        country_code: res.countryCode,
        number: res.phoneNumber,
        first_name: res.firstName

    }).then(
        (res) => res,
        (err) => err
    );

export const socialLogin = (res: { userEmail: string, Title: string, titleValue: string, loginSource: string }) =>
    API.post("/social/login", {
        username: res.userEmail,
        title: res.Title,
        value: res.titleValue,
        source: res.loginSource
    }).then(
        (res) => res,
        (err) => err
    );


export const customerUpdateProfile = (userObj: { first_name: string, last_name: string, email: string, user_id: string, dob: string, gender: string }, token: string, userId: number) =>
    API.post("/customer/profile", {
        first_name: userObj.first_name,
        last_name: userObj.last_name,
        email: userObj.email,
        user_id: userId,
        dob: userObj.dob,
        gender: userObj.gender
    }, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": `multipart/form-data`,
        },
    }).then(
        (res) => res,
        (err) => err
    );

export const getTablesOld = () =>
    API.get("/table", {
        headers: {
            Authorization: `Bearer ${process.env.REACT_WAITER_TOKEN}`,
            "Content-type": `multipart/form-data`,
        },
    }).then(
        (res) => res,
        (err) => err
    );

export const getTables = (token: string, page: any) =>
    API.get(`/devices/waiter/tables`, {
        headers: {
            // Response: 'detail',
            Response: 'invoices',
            Authorization: `Bearer ${token}`,
            "Content-type": `multipart/form-data`,
            
        },
    }).then(
        (res) => res,
        (err) => err.response
    );
    export const getTablesType = (token: string, page: any) =>
    API.get(`/devices/waiter/tables/type`, {
        headers: {
            Response: 'detail',
            Authorization: `Bearer ${token}`,
            "Content-type": `multipart/form-data`,
        },
    }).then(
        (res) => res,
        (err) => err.response
    );


export const getTablesInvoices = (body: any, token: any, page: any) =>
    API.post(`/devices/waiter/invoices`, body, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": `multipart/form-data`,
            Response: 'list',
        },
    }).then(
        (res) => res,
        (err) => err
    );
export const SearchTablesInvoics = (body: any, token: any,) =>
    API.post(`/devices/waiter/invoices`, body, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": `multipart/form-data`,
            Response: 'list'
        },
    }).then(
        (res) => res,
        (err) => err
    );
export const getInvoice = (id: any) =>
    API.get(`order_invoice/${id}`).then(
        (res) => res,
        (err) => err.response
    );

export const checkAuth = (body: any) =>
    API.post(`/devices/login/`, body, {
        headers: {
            "Content-Type": "application/json"
        },
    }).then(
        (res) => res,
        (err) => err.response
    );
    export const getBookingInvoice = (id: any,token:any) =>{
        console.log(id)
        API.get(`booking/single/${id}`,{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(
            (res) => res,
            (err) => err.response
        );
    }


export const invoiceCompleted = (id: any,token:any) =>
API.post(`/devices/booking/completed/${id}`,{}, {
    headers: {
        Authorization: `Bearer ${token}`,
    },
}).then(
    (res) => res,
    (err) => err
);


export const waiterService = {
    login,
    sendOtp,
    guestOtp,
    socialLogin,
    checkGuestOtp,
    customerUpdateProfile,
    getTablesOld,
    getTables,
    getTablesInvoices,
    getInvoice,
    checkAuth,
    SearchTablesInvoics,
    getTablesType,
    getBookingInvoice,
    invoiceCompleted,
    
};